
















import { listFactory } from '@/main/pages';
import { PageMode } from '@/main/utils/pageMode';
import { openEdit } from '@/main/router/routerPath';
import { store } from './store/list';
import { NAME, ORDER_STATUS } from './constants';
import { apiProvider as PROrdersProvider} from '@/modules/sklad/PROrders/api';

export default listFactory(NAME, store).extend({
	data() {
        return{            
            disableImportTripod: false as boolean,            
        };
    },
	computed: {
		shouldDisplayTripod() {
			return this.$route.params.mode === PageMode.LIST
		}
	},
	created() {
		PROrdersProvider.importTripodOrders();
	},
	methods: {
		editClick(event: any) {
			if (event.data.STATUS === ORDER_STATUS.CLOSED) {
				openEdit(NAME, PageMode.VIEW, { id: event.data.ORDER_NO });
			} else {
				openEdit(NAME, PageMode.EDIT, { id: event.data.ORDER_NO });
			}
		},
		async importTripodOrders(){
			this.startLoading();
			await PROrdersProvider.importTripodOrders();
			this.endLoading();
			if(this.dmsSys.SendToEdfsPrp) {
				this.disableImportTripod=true;
				try {
					await PROrdersProvider.createEdfsSalesOrderForTripodOrder();
				} 
			   finally{
				  this.disableImportTripod=false; 
			   }
			}
			await this.tableData();
			(this.$refs.table as any).refreshLayout();			
		},
	},
});
